var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineReceiptDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 11.75c-.41 0-.75-.34-.75-.75V4.01c0-.74.29-1.43.81-1.95s1.21-.81 1.95-.81h.01c1.25.01 2.43.5 3.33 1.39.9.91 1.39 2.11 1.39 3.36v2.42c.01 1.99-1.33 3.33-3.32 3.33H16zm3.42-1.5c1.16 0 1.83-.67 1.83-1.83V6c0-.86-.34-1.68-.95-2.3-.61-.6-1.43-.94-2.28-.95h-.01c-.33 0-.65.13-.89.37s-.37.55-.37.89v6.24h2.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76 22.81 6.1 21.14a.246.246 0 0 0-.33-.02L4.06 22.4c-.53.4-1.23.47-1.83.17-.6-.3-.97-.9-.97-1.57V6c0-3.02 1.73-4.75 4.75-4.75h12c.41 0 .75.34.75.75s-.34.75-.75.75c-.69 0-1.25.56-1.25 1.25v17c0 .67-.37 1.27-.97 1.57-.6.3-1.3.24-1.83-.16l-1.71-1.28a.243.243 0 0 0-.32.02l-1.68 1.68c-.34.32-.78.5-1.25.5s-.91-.18-1.24-.52zm-.6-2.72 1.66 1.67c.06.06.14.07.18.07.04 0 .12-.01.18-.07l1.68-1.68c.62-.62 1.6-.68 2.29-.15l1.7 1.27c.11.08.21.05.26.02.05-.03.14-.09.14-.22V4c0-.45.11-.88.3-1.25H6C3.78 2.75 2.75 3.78 2.75 6v15c0 .14.09.2.14.23.06.03.16.05.26-.03l1.71-1.28c.31-.23.68-.35 1.05-.35.46 0 .91.17 1.25.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.43 13.08c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1c-.56 0-1-.45-1-1zM5.57 9.03c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1c-.56 0-1-.45-1-1zM5.74 14.26a.754.754 0 0 1 0-1.06l5.46-5.46c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L6.8 14.26c-.14.14-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineReceiptDiscount);
export default __webpack_public_path__ + "static/media/vuesax-outline-receipt-discount.209533d4a412ad31d49910927c416c01.svg";
export { ForwardRef as ReactComponent };